import { fragSamplerOverlay } from '../shaders/frag-sampler-overlay.shader';
import { vertSampler } from '../shaders/vert-sampler.shader';

import { TexturePipelineBase } from './pipeline-texBase';

/**
 * This pipeline must run with 2 textures, the first being the texture on the bottom, and the second being on top of it.
 */
export class OverlayedTexturePipeline extends TexturePipelineBase {
  public constructor() {
    super(vertSampler, fragSamplerOverlay);
  }

  public CreateTextures(imgDataList: ImageData[]): WebGLTexture[] {
    if (imgDataList.length !== 2) {
      throw new Error(`CreateTextures called without exactly 2 textures.`);
    }

    return super.CreateTextures(imgDataList);
  }

  public SetGlTextures(textures: WebGLTexture[]) {
    if (textures.length !== 2) {
      throw new Error(`SetGlTextures called without exactly 2 textures.`);
    }

    // ! The overlay textures seems to be coming out reversed... element 0 on top, an element 1 on the bottom.
    // ! Reversing here to correct this occurance. :/
    textures.reverse();
    super.SetGlTextures(textures);
  }
}
